import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VideoState, videoAdapter } from '../reducers/video.reducer';

export const getVideoState = createFeatureSelector<VideoState>('videos');
export const getIds = (state: VideoState) => state.ids;
export const loading = (state: VideoState) => state.loading;

export const {
  selectIds: getVideoIds,
  selectEntities: getVideoEntities,
  selectAll: getAllVideos,
  selectTotal: getTotalVideos,
} = videoAdapter.getSelectors(getVideoState);

export const getItemById = (id: string) =>
  createSelector(getAllVideos, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === id;
      });
    } else {
      return null;
    }
  });
